exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-40385381]{padding:12px 16px;background-color:#f8f9fa;border:1px solid #e9ecef;border-radius:4px;margin-bottom:16px;line-height:1.6;color:#666;font-size:14px}.tips-list[data-v-40385381]{padding-left:20px}.tips-list[data-v-40385381],.tips-list li[data-v-40385381]{list-style:disc}.tips-list-sub[data-v-40385381]{padding-left:20px}.tips-list-sub[data-v-40385381],.tips-list-sub li[data-v-40385381]{list-style:circle}.tips-link[data-v-40385381]{margin-top:8px}.tips-link a[data-v-40385381]{cursor:pointer;font-weight:600}", ""]);

// exports
